import "leaflet/dist/leaflet.css";
import React, { useContext, useEffect, useState } from "react";
import { MdOutlineRefresh } from "react-icons/md";
import animation from "../../images/jm-animation.gif";
import "./KycForm.css";
import KycForm2 from "./KycForm2";
import URLstateContext from "../../provider/CommonContext";
import { EncryptAES } from "../../provider/ServiceProvider";
// import CryptoJS from "crypto-js";
// import { EncryptAES} from "../../provider/ServiceProvider";

function KycForm() {
  const { BaseURL } = useContext(URLstateContext);
  const [pancard, setPancard] = useState("");
  const [pancardError, setPancardError] = useState("");
  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [message, setMessage] = useState("");
  const [loadingshow, setLoadingshow] = useState(false);
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const canvas = document.getElementById("captcha");
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captchaCode = "";

    const minRotation = -45;
    const maxRotation = 45;
    const rotationRange = maxRotation - minRotation;

    const minFontSize = 20;
    const maxFontSize = 30;
    const fontSizeRange = maxFontSize - minFontSize;

    for (let i = 0; i < 4; i++) {
      const randomCharacter = characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
      captchaCode += randomCharacter;
      const fontSize = minFontSize + Math.random() * fontSizeRange;
      ctx.font = `${fontSize}px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      const textColor = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(
        Math.random() * 256
      )}, ${Math.floor(Math.random() * 256)})`;
      ctx.fillStyle = textColor;
      const rotation = minRotation + Math.random() * rotationRange;
      ctx.translate(20 + i * 30, canvas.height / 2);
      ctx.rotate((rotation * Math.PI) / 180);
      ctx.fillText(randomCharacter, 0, 0);
      ctx.rotate((-rotation * Math.PI) / 180);
      ctx.translate(-(20 + i * 30), -canvas.height / 2);
    }
    setCaptchaCode(captchaCode);
  };

  // const handlePancardChange = (e) => {
  //   setShowComponent(false);
  //   const value = e.target.value.toUpperCase();
  //   const alphanumericRegex = /^[a-zA-Z0-9]*$/;

  //   if (alphanumericRegex.test(value)) {
  //     setPancard(value);
  //     setPancardError("");
  //   } else {
  //     setPancardError("Only alphanumeric characters are allowed.");
  //   }
  //   setMessage("");
  // };


  const handlePancardChange = (e) => {
  let value = e.target.value.toUpperCase();
  const maxLength = 10;

  // Remove any character that doesn't belong at that position
  let formatted = "";

  for (let i = 0; i < value.length && i < maxLength; i++) {
    const char = value[i];

    if (i < 5) {
      // First 5 characters must be letters
      if (/^[A-Z]$/.test(char)) {
        formatted += char;
      }
    } else if (i < 9) {
      // Positions 6-9 must be numbers
      if (/^[0-9]$/.test(char)) {
        formatted += char;
      }
    } else {
      // 10th character must be letter
      if (/^[A-Z]$/.test(char)) {
        formatted += char;
      }
    }
  }

  setPancard(formatted);
  setShowComponent(false);

  // Error handling
  // if (formatted.length > 0 && formatted.length < 10) {
  //   setPancardError("PAN must be in format: AAAAA9999A");
  // } else if (formatted.length === 10) {
  //   setPancardError("");
  // } else {
  //   setPancardError("");
  // }

  setMessage("");

  if (pancardError) {
    setPancardError("");
  }
};


  const handleCaptchaChange = (e) => {
    setCaptchaInput(e.target.value);
    setCaptchaError("");

    if (captchaError) {
    setCaptchaError("");
  }
  };

  const handleRefreshCaptcha = () => {
    generateCaptcha();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingshow(true);
    if (!pancard) {
      setLoadingshow(false);
      setPancardError("PAN Number is required.");
      return;
    }

    if (!pancard.match(/[A-Z]{5}[0-9]{4}[A-Z]{1}/)) {
      setLoadingshow(false);
      setPancardError("Enter your 10-character Permanent Account Number in the format ABCDE1234F.");
      return;
    }

    if (!captchaInput) {
      setLoadingshow(false);
      setCaptchaError("Captcha is required. Enter the characters shown in the image.");
      return;
    } else if (captchaInput !== captchaCode) {
      setLoadingshow(false);
      setCaptchaError("The CAPTCHA you entered is incorrect. Please try again with the new CAPTCHA.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    // const apiBaseUrl =
    //   window.location.hostname === "localhost"
    //     ? "http://localhost:5218"
    //     : "https://jmmfapi.jmfinancialmf.com";


        const apiBaseUrl =
  window.location.hostname === "localhost"
    ? "http://localhost:5218"
    : window.location.hostname === "cmotswebnew"
    ? "http://cmotswebnew:710"
    : "https://jmmfapi.jmfinancialmf.com";

   const encryptedPan = EncryptAES(pancard);
   const encodedEncryptedPan = encodeURIComponent(encryptedPan);

    try {
      const response = await fetch(
        // `https://jmmfapi.jmfinancialmf.com/api/GetPanDetails?PANNumber=${pancard}`,
        // `http://localhost:5218/api/GetPanDetails?PANNumber=${encodedEncryptedPan}`,
        `${apiBaseUrl}/api/GetPanDetails?PANNumber=${encodedEncryptedPan}`,

        {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
          },
          body: "",
          redirect: "follow",
        }
      );

      const result = await response.text();
      
      setLoadingshow(false);
      alert(result);
      

      let displayMessage = "";

      if (result.includes("KYC REGISTERED")) {
        displayMessage = (
          <span style={{ color: "green" }}>
            Your PAN is KYC registered. Please get it validated by{" "}
            <span
              style={{ color: "blue" }}
              className="hover-effect"
              onClick={handleClick}
            >
              Get it Validated
            </span>
            .
          </span>
        );
      } else if (result.includes("The KYC is not available with the KRA.")) {
        displayMessage = (
          <span style={{ color: "green" }}>
            The KYC is not available with the KRA. Please get it validated by{" "}
            <span
              style={{ color: "blue" }}
              className="hover-effect"
              onClick={handleClick}
            >
              Get it Validated
            </span>
            .
          </span>
        );
      } else if (
        result.includes(
          "Old KYC which is incomplete. KYC cannot be completed online. Client must submit a physical document."
        )
      ) {
        displayMessage = (
          <span style={{ color: "green" }}>
            Old KYC which is incomplete. KYC cannot be completed online. Client
            must submit a physical document.{" "}
            <span
              style={{ color: "blue" }}
              className="hover-effect"
              onClick={handleClick}
            >
              Get it Validated
            </span>
            .
          </span>
        );
      } else if (
        result.includes("ON HOLD") ||
        result.includes("KYC REJECTED")
        // result.includes("Incomplete KYC (Existing / OLD Record)")
      ) {
        displayMessage = (
          <span style={{ color: "green" }}>
            Your KYC is on Hold/Rejected. Please submit your KYC documents again
            by{" "}
            <span
              style={{ color: "blue" }}
              className="hover-effect"
              onClick={handleClick}
            >
              Get it validated
            </span>
            .
          </span>
        );
      } else if (
        result.includes("UNDER_PROCESS") ||
        result.includes("ON HOLD- Incomplete KYC (Existing / OLD Record)")
      ) {
        displayMessage =
          "Your KYC is under process. You will get KYC status confirmation soon.";
      }

      setMessage(displayMessage);

      setCaptchaInput("");
      generateCaptcha();
    } catch (error) {
      console.error("Error fetching PAN details:", error);
      setLoadingshow(false);
      alert(
        "There was an error fetching the PAN details. Please try again later."
      );
    }
  };

  const handleClick = () => {
    setShowComponent(true);
  };

  return (
    <div>
      {/* <div style={{ display: "flex", justifyContent: "center" }} className="mainInnerKycForm"> */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: 500, marginBottom: 10 }}>
          <div
            style={{
              backgroundColor: "#FFFFFF",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
              zIndex: 0,
              position: "relative",
            }}
            // className="innerKycForm"
          >
            {loadingshow && (
              <div
                className="textcentervertex"
                style={{
                  position: "absolute",
                  bottom: "35%",
                  left: "40%",
                  zIndex: 1,
                }}
              >
                <img src={animation} alt="Loading" />
                <div className="model_popup">Please Wait...</div>
              </div>
            )}
            {/* <form onSubmit={handleSubmit}  className={`custom-form ${loadingshow ? "blur" : ""}`}> */}
            <form onSubmit={handleSubmit} className={loadingshow ? "blur" : ""}>
              <div style={{ marginBottom: 20 }}>
                <label
                  htmlFor="panNumber"
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontWeight: "600",
                  }}
                >
                  PAN Number{" "}
                  <span style={{ color: "#D32F2F" }} aria-hidden="true">
                    *
                  </span>
                </label>
                <input
                  style={{
                    width: "100%",
                    padding: 10,
                    boxSizing: "border-box",
                    border: "none",
                    borderBottom: `2px solid ${
                      pancardError ? "red" : "#CCCCCC"
                    }`,
                    borderRadius: 0,
                    outline: "none",
                    transition: "border-color 0.3s",
                  }}
                  id="panNumber"
                  type="text"
                  placeholder="Enter your PAN"
                  autoComplete="off"
                  maxLength={10}
                  value={pancard}
                  onChange={handlePancardChange}
                  onBlur={() => {
                      if (pancard.length === 0) {
                        setPancardError("Please enter your PAN card number.");
                      } else if (pancard.length < 10) {
                        setPancardError("PAN number must be 10 characters long.");
                      } else if (!/[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(pancard)) {
                        setPancardError("Please enter a valid PAN card number.");
                      } else {
                        setPancardError(""); // Clear if fully valid
                      }
                    }}
                  aria-invalid={!!pancardError}
                  aria-describedby={pancardError ? "pan-error" : undefined}
                  aria-errormessage={pancardError ? "pan-error" : undefined}
                  onFocus={(e) => {
                    e.target.style.borderBottom = "2px solid #3fb9d1";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderBottom = `2px solid ${
                      pancardError ? "red" : "#CCCCCC"
                    }`;
                  }}
                />
                {pancardError && (
                  <p
                    style={{ color: "red", fontSize: 12 }}
                    id="pan-error"
                    role="alert"
                  >
                    {/* <div style={{ color: "red", fontSize: 12 }}  className="pancardError">  */}
                    {pancardError}
                  </p>
                )}
              </div>
              <div style={{ marginBottom: 20, display: "flex" }}>
                <div style={{ border: "1px solid #E4E4E7", borderRadius: 4 }}>
                  <canvas id="captcha" width="140" height="50"></canvas>
                </div>
                <button
                  type="button"
                  onClick={handleRefreshCaptcha}
                  aria-label="Refresh captcha"
                  style={{
                    marginLeft: "auto",
                    backgroundColor: "#013c66",
                    // color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                    fontWeight: "bold",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                  //  className="refresh-btn"
                >
                  <MdOutlineRefresh

                    size={21}
                    style={{fill : '#fff'}}
                    aria-hidden="true"
                    focusable="false"
                  />
                  <span className="sr-only"> Refresh Captcha</span>
                </button>
              </div>
              <div style={{ marginBottom: 20 }}>
                <label
                  htmlFor="captchaInput"
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontWeight: "600",
                  }}
                >
                  Captcha{" "}
                  <span style={{ color: "#D32F2F" }} aria-hidden="true">
                    *
                  </span>
                </label>

                <input
                  style={{
                    width: "100%",
                    padding: 10,
                    boxSizing: "border-box",
                    border: "none",
                    borderBottom: `2px solid ${
                      captchaError ? "red" : "#CCCCCC"
                    }`,
                    borderRadius: 0,
                    outline: "none",
                    transition: "border-color 0.3s",
                  }}
                  id="captchaInput"
                  type="text"
                  autoComplete="off"
                  value={captchaInput}
                  onChange={handleCaptchaChange}
                  maxLength={4}
                  placeholder="Enter Captcha"
                  aria-invalid={!!captchaError}
                  aria-describedby={captchaError ? "captcha-error" : undefined}
                  aria-errormessage={captchaError ? "captcha-error" : undefined}
                  onFocus={(e) => {
                    e.target.style.borderBottom = "2px solid #3fb9d1";
                  }}
                  onBlur={(e) => {
                    e.target.style.borderBottom = `2px solid ${
                      captchaError ? "red" : "#CCCCCC"
                    }`;
                  }}
                />
                {captchaError && (
                  <p
                    style={{ color: "red", fontSize: 12 }}
                    id="captcha-error"
                    role="alert"
                  >
                    {captchaError}
                  </p>
                )}
              </div>
              <div>
                <button
                  type="submit"
                  style={{
                    width: "100%",
                    backgroundColor: "#013c66",
                    color: "#fff",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: 4,
                    cursor: "pointer",
                    fontWeight: "bold",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                  
                   className="submit-btn"
                >
                  Submit
                </button>
              </div>
            </form>
            {message && (
              <div
                style={{
                  marginTop: 20,
                  color: "#333",
                  fontWeight: "bold",
                  fontSize: "13px",
                  width: "full",
                }}
              >
                {message}
              </div>
            )}
          </div>
        </div>
      </div>
      {showComponent && (
        <div style={{ marginTop: "20px" }}>
          <KycForm2 pancard={pancard} />
        </div>
      )}
    </div>
  );
}

export default KycForm;
